
export const mutBlogs = (state, blogs) => {
    state.blogs = blogs
}
/*
export const updateBlog = (state, blog) =>{
    const idx = state.blogs.map( e => e.id ).indexOf( blog.id )
    state.blogs[idx] = blog
}*/
export const addBlog = (state, blog) => {
    state.blogs = [blog, ...state.blogs]
}

export const selectBlog = (state, b) => {
    state.blog = b
}

export const deleteBlog = (state, id) => {
    state.blogs = state.blogs.filter(blog => blog.id !== id)
}
export const deleteBlogImagen = (state, id) => {
    state.blogs.imagenes = state.blogs.imagenes.filter(blog => blog.imagenes.id !== id)
}